import { useEffect, useRef, useState } from "react";
import { useTheme } from "../../context/ThemeContext.jsx";

/**
 * Bouton « Apparence » : ouvre un petit menu Clair / Sombre / Automatique.
 * Se place dans la barre du haut (Topbar). L'icône reflète le choix actuel.
 */
const OPTIONS = [
  { id: "light",  label: "Clair",       icon: "bi-sun" },
  { id: "dark",   label: "Sombre",      icon: "bi-moon-stars" },
  { id: "system", label: "Automatique", icon: "bi-circle-half" },
];

export default function ThemeToggle() {
  const { pref, setPref } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = OPTIONS.find(o => o.id === pref) || OPTIONS[0];

  // Ferme le menu au clic extérieur ou avec Échap
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDown); document.removeEventListener("keydown", onKey); };
  }, [open]);

  return (
    <div className="theme-toggle" ref={ref}>
      <button type="button" className="itm-topbar-btn" title={`Apparence : ${current.label}`}
        aria-label="Changer l'apparence" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(o => !o)}>
        <i className={`bi ${current.icon}`} />
      </button>
      {open && (
        <div className="theme-menu" role="menu">
          {OPTIONS.map(o => (
            <button key={o.id} type="button" role="menuitemradio" aria-checked={pref === o.id}
              className={`theme-menu-item${pref === o.id ? " active" : ""}`}
              onClick={() => { setPref(o.id); setOpen(false); }}>
              <i className={`bi ${o.icon}`} />
              <span>{o.label}</span>
              {pref === o.id && <i className="bi bi-check2 theme-menu-check" />}
            </button>
          ))}
        </div>
      )}
      <style>{CSS}</style>
    </div>
  );
}

const CSS = `
.theme-toggle { position: relative; }
.theme-menu {
  position: absolute; top: calc(100% + 8px); right: 0; z-index: 200;
  min-width: 170px; padding: 6px;
  background: var(--card-bg); border: 1px solid var(--border-md); border-radius: 12px;
  box-shadow: 0 12px 36px rgba(0,0,0,.25);
}
.theme-menu-item {
  display: flex; align-items: center; gap: 10px; width: 100%;
  padding: 8px 10px; border: none; border-radius: 8px; background: none; cursor: pointer;
  font: inherit; font-size: 13px; color: var(--text-1); text-align: left;
}
.theme-menu-item:hover { background: var(--navy-hover); }
.theme-menu-item.active { color: var(--accent); font-weight: 600; }
.theme-menu-item i { font-size: 14px; }
.theme-menu-check { margin-left: auto; }
`;
